/* eslint-disable */
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { http, type Meta } from "~/foundation/Api";

export const membershipSignupPromptServiceMeta: Meta<typeof membershipSignupPromptService> = {
	signupPromptStart: ["GET", "/api/v1/membership/signup/prompt/start"],
};

// Feature.Membership.Controllers.Api.ApiV1MembershipSignupPromptController
export const membershipSignupPromptService = {
	async signupPromptStart() {
		return await http.fetch<undefined, undefined>(membershipSignupPromptServiceMeta.signupPromptStart, {  });
	},
};
